import React from "react";


const styles = {

    panel: {

        display:
            "flex",

        alignItems:
            "center",

        padding:
            "0px 20px",

        borderRadius:
            "0px",

        height:
            "54px",

        gap:
            "14px",

        background:
            "linear-gradient(180deg,#171b20 0%,#0c0f12 100%)",

        boxShadow:
            "0 8px 20px rgba(0,0,0,0.22)",

        border:
            "1px solid rgba(255,255,255,0.08)",

        borderBottom:
            "2px solid #20afe8",

        color:
            "white"

    },

    button: isActive => ({

        padding:
            "8px 14px",

        borderRadius:
            "0px",

        border:
            isActive
                ? "1px solid rgba(32,175,232,0.55)"
                : "1px solid rgba(255,255,255,0.10)",

        borderBottom:
            isActive
                ? "2px solid #20afe8"
                : "1px solid rgba(255,255,255,0.10)",

        cursor:
            "pointer",

        background:
            isActive
                ? "rgba(32,175,232,0.12)"
                : "rgba(255,255,255,0.035)",

        color:
            isActive
                ? "#ffffff"
                : "rgba(255,255,255,0.72)",

        fontSize:
            "13px",

        fontWeight:
            isActive
                ? 600
                : 400,

        transition:
            "all 0.2s ease",

        width:
            "100px",

        boxShadow:
            isActive
                ? "0 4px 12px rgba(0,0,0,0.16)"
                : "none"

    })

};

export default function FloorplanModeToolbar({ mode, setMode }) {
  return (
    <div style={styles.panel}>
      <button style={styles.button(mode === "intensity")} onClick={() => setMode("intensity")}>
        Intensity
      </button>

      <button style={styles.button(mode === "activity")} onClick={() => setMode("activity")}>
        Activity
      </button>
	  
	  <button style={styles.button(mode === "organisation")} onClick={() => setMode("organisation")}>
	      Department
	    </button>

      <button style={styles.button(mode === "gaussian-rag")} onClick={() => setMode("gaussian-rag")}>
        Gaussian
      </button>
    </div>
  );
}



